/* eslint-disable */
<template>

  <div>
    <EnergisaHome v-if="tenantType === 'ENERGY'"/>

    <GalapagosHome v-if="tenantType === 'FINANCE'"/>
  </div>

</template>

<script>
import EnergisaHome from '../views/home/EnergisaHome'
import GalapagosHome from '../views/home/GalapagosHome'
import UserAuthorization from "@/mixins/UserAuthorization";
import axios from "axios";

export default {
  mixins:[UserAuthorization],
  components: {
    EnergisaHome,
    GalapagosHome,
  },
  data () {
    return {
      tenantType: null,
    }
  },
  beforeMount() {
    this.loadTenantType()
  },
  methods: {
    loadTenantType() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant-type`)
        .then((response) => {
          this.tenantType = response.data
        })
    }
  }
}

</script>
